__turbopack_context__.v({
  "ageProfile": "XST6LG_ageProfile",
  "ageProfiles": "XST6LG_ageProfiles",
  "collapseButton": "XST6LG_collapseButton",
  "content": "XST6LG_content",
  "details": "XST6LG_details",
  "ranges": "XST6LG_ranges",
});
